"use strict";

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeAll = void 0;

var _Observable = require("./Observable");

var mergeAll = function mergeAll(obs) {
  return (0, _Observable.mkObservable)(function (observer) {
    //TODO: count completed observables
    obs.map(function (o) {
      o.subscribe({
        next: function next(v) {
          observer.next(v);
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return void 6;
        } //observer.complete()

      });
    });
  });
};

exports.mergeAll = mergeAll;